import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getListTicket, updateDataSearch } from  "actions/Ticket";
import { ThemMoiTicket } from "./ThemMoiTicket";
export const AddTicketBtn = () => {
   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);

  return (
    <div className="hide-table-main show-mobile-main hidden-des-main">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 15,
          marginBottom: 15,
        }}
      >
        {/* <div style={{ display: "block" }}>
          <div className="row">
            <div className="col-sm-12 col-md-12">
              <div className="media-home align-center-home">
                <div className="bg-icon-bredcrumb">
                  <i class="mdi mdi-car"></i>
                </div>
                <div className="media-body-home">
                  <h2 className="text-info-home">Ticket</h2>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div>
          <button
            type="button"
            className="btn btn-border-new"
            onClick={handleShow}
          >
            <i className="mdi mdi-plus"></i> Thêm mới
          </button>
        </div>
         {show && <ThemMoiTicket show={show} onHide={handleClose} />}
      </div>
    </div>
  );
};
